module.exports = __webpack_public_path__ + "static/media/waterFilterExplore.1471e819.png";